import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const PrePartyCard = () => {
  return (
    <section className="bg-yacht-charcoal py-16 md:py-20 px-4">
      <div className="max-w-2xl mx-auto">
        <motion.p
          className="text-center text-[#A8FF2F] text-xs md:text-sm font-black tracking-[0.25em] uppercase mb-4"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          The Official YRD Pre-Party
        </motion.p>

        <motion.h2
          className="text-center text-yacht-cream text-3xl md:text-5xl mb-10 leading-tight"
          style={{ fontFamily: "Georgia, 'Times New Roman', serif", fontWeight: 400, fontStyle: "italic" }}
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Party Pupils on the<br />CieLo Rooftop
        </motion.h2>

        <Link
          to="/preparty"
          className="block group relative overflow-hidden rounded-3xl bg-black border border-white/10 hover:border-[#A8FF2F]/40 transition-colors"
        >
          <div className="relative aspect-[3/2] overflow-hidden">
            <picture>
              <source media="(max-width: 640px)" srcSet="/pp-photo-sm.webp" />
              <img
                src="/pp-photo.webp"
                alt="Party Pupils — Ryan Siegel"
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover"
                style={{ objectPosition: "center 15%", filter: "saturate(0.9) contrast(1.05)" }}
              />
            </picture>
            <div
              className="absolute inset-0"
              style={{
                background:
                  "radial-gradient(ellipse at 50% 40%, rgba(0,0,0,0) 30%, rgba(0,0,0,0.55) 100%), linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(10,10,10,0.95) 100%)",
              }}
            />

            <div className="absolute top-4 left-4 z-10 bg-yacht-cream text-yacht-charcoal rounded-xl px-3 py-1.5 shadow-lg flex flex-col items-center min-w-[54px]">
              <div className="text-[9px] font-black tracking-[0.14em] uppercase text-[#a31919]">May</div>
              <div className="text-xl font-black leading-none mt-px">23</div>
            </div>

            <div className="absolute top-4 right-4 z-10 bg-[#A8FF2F] text-yacht-charcoal font-black text-[10px] tracking-[0.14em] uppercase px-3 py-2 rounded-full shadow-lg">
              $20
            </div>

            <img
              src="/pp-logo.webp"
              alt="Party Pupils"
              className="absolute left-1/2 bottom-[6%] -translate-x-1/2 w-[42%] max-w-[200px] z-10"
              style={{ filter: "drop-shadow(0 4px 16px rgba(168,255,47,.55)) drop-shadow(0 2px 8px rgba(0,0,0,.8))" }}
            />
          </div>

          <div className="p-5 md:p-6">
            <p className="text-[#A8FF2F] text-[10.5px] md:text-xs font-black tracking-[0.2em] uppercase mb-2">
              Saturday · May 23 · Cambria Detroit
            </p>
            <p className="text-yacht-cream/80 text-sm md:text-base mb-5 leading-relaxed">
              Yacht-house DJ set on the CieLo Rooftop. $20.
            </p>

            <div className="flex items-center justify-between gap-3 bg-[#A8FF2F] text-yacht-charcoal rounded-full px-5 py-3 font-black text-sm tracking-wider uppercase group-hover:bg-[#bbff5c] transition-colors">
              <span>Get Tickets</span>
              <span aria-hidden="true" className="text-xl leading-none">→</span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default PrePartyCard;
